export default __webpack_public_path__ + "static/media/newsletter-layout.5b388f98.webp";